<h1 mat-dialog-title>
  <div class="d-flex align-items-center justify-content-between">
    <div>
      <i class="i-16 mr-8 {{titleIcon ?? 'fas fa-exclamation-triangle'}}"></i>
      <span>{{title}}</span>
    </div>
    <div *ngIf="showClose">
      <button trgButton class="dialog-close-btn" [disabled]="busy()">
        <i class="fal fa-times i-12 p-relative ot-1"></i>
      </button>
    </div>
  </div>
</h1>
<div mat-dialog-content class="text-center">
  <ng-container *ngIf="noContent">
    <p class="c-grey-5 fs-14 ws-pre">{{message}}</p>
  </ng-container>
  <ng-container *ngIf="contentTemplate; else HTMLContent">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </ng-container>
  <ng-template #HTMLContent>
    <div [innerHTML]="contentString"></div>
  </ng-template>
</div>
<div mat-dialog-actions align="center">
  <button
    *ngFor="let btn of buttons; let last = last"
    trgButton
    [color]="btn.color"
    class="min-w-100"
    (click)="onButtonClick(btn)"
    [disabled]="busy()"
    [attr.cdkFocusInitial]="last">
    {{ btn.title }}
  </button>
</div>
